import React, { Component } from 'react';
import '../../../../../styles/components/vehicle-register.scss';

class WeightTicketPrint extends Component {
  constructor(props) {
    super(props);
    this.printRef = React.createRef();
  }

  formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '';
      return date.toLocaleDateString('en-GB').split('/').join('/');
    } catch (error) {
      return '';
    }
  };

  formatTime = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '';
      return date.toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' });
    } catch (error) {
      return '';
    }
  };

  getSafeValue = (obj, path, defaultValue) => {
    try {
      const value = path.split('.').reduce((o, key) => (o && o[key] !== undefined ? o[key] : undefined), obj);
      return value !== undefined ? value : defaultValue;
    } catch (error) {
      return defaultValue;
    }
  };

  render() {
    const { ticket = {}, driver = {}, vehicle = {}, deliverySite = {}, material } = this.props;

    // Safe value extraction
    const gatePassNumber = this.getSafeValue(ticket, 'gatepass_number', '00555');
    const weightTicket = this.getSafeValue(ticket, 'weight_ticket', '000062');
    const buyer_name = this.getSafeValue(ticket, 'buyer_name');
    const poNumber = this.getSafeValue(ticket, 'po_number', 'PO- 4501008768');
    const vehicleNumber = this.getSafeValue(vehicle, 'vehicle_number', '300 DK/419 MH');
    const materialName = material ||
      this.getSafeValue(ticket, 'delivery_site.material.name', '') ||
      this.getSafeValue(ticket, 'materialType', '') ||
      'No Material Specified';
    const auctionName = this.getSafeValue(deliverySite, 'auction_name', 'Sohar Steel LLC');
    const projectName = this.getSafeValue(deliverySite, 'project_name', 'Sohar');
    const driverName = this.getSafeValue(driver, 'name');
    const licenseNumber = this.getSafeValue(driver, 'license_number');
    const driverMobile = this.getSafeValue(driver, 'phone');

    const tareWeight = this.getSafeValue(ticket, 'tare_weight', 17110);
    const grossWeight = this.getSafeValue(ticket, 'gross_weight', 42080);
    const netWeight = this.getSafeValue(ticket, 'net_weight', 24970);

    const entryTime = this.getSafeValue(ticket, 'entry_time', '');
    const exitTime = this.getSafeValue(ticket, 'exit_time', '');

    return (
      <div
        ref={this.props.forwardedRef || this.printRef}
        className="weight-ticket-print"
      >
        <div className="ticket-border">
          {/* Company Header */}
          <div className="company-header">
            <img
              src={process.env.PUBLIC_URL + '/assets/images/logo-org.png'}
              alt="Mzadcom Logo"
              className="prof-navbar__logo-img"
            />

            <div className="company-name">
              <h2>Mzadcom Smart Auction Solution LLC</h2>
              <div className="company-location">Fahud</div>
            </div>
            <div className="ticket-info-header">
              <div className="gate-pass">
                <strong>Gate Pass No:</strong> {gatePassNumber}
              </div>
              <div className="ticket-title">
                <h2>WEIGHT TICKET <span className="ticket-number">{weightTicket}</span></h2>
              </div>
            </div>
          </div>

          <div className="divider-line"></div>

          {/* Vehicle Information */}
          <div className="section vehicle-info">
            <div className="section-title">License plate no.</div>
            <div className="section-content large-text">
              {vehicleNumber}
            </div>
          </div>

          {/* Material Information */}
          <div className="section material-info">
            <div className="section-title">MATERIAL</div>
            <div className="section-content">
              {materialName}
            </div>
          </div>

          {/* Customer Information */}
          <div className="section customer-info">
            <div className="section-title">CUSTOMER</div>
            <div className="section-content">
              {buyer_name}
            </div>
          </div>

          <div className="two-column-section">
            {/* Left Column - Supplier/Source */}
            <div className="column">
              <div className="info-row">
                <div className="label">SUPPLIER</div>
                <div className="value">PDO</div>
              </div>
              <div className="info-row">
                <div className="label">SOURCE</div>
                <div className="value">Fahud</div>
              </div>
              <div className="info-row">
                <div className="label">DESTINATION</div>
                <div className="value">{projectName}</div>
              </div>
            </div>

            {/* Right Column - Driver Info */}
            <div className="column">
              <div className="info-row">
                <div className="label">DRIVER NAME</div>
                <div className="value">{driverName}</div>
              </div>
              <div className="info-row">
                <div className="label">DRIVER ID</div>
                <div className="value">{licenseNumber}</div>
              </div>
              <div className="info-row">
                <div className="label">DRIVER GSM</div>
                <div className="value">{driverMobile}</div>
              </div>
            </div>
          </div>

          <div className="divider-line thick"></div>

          {/* Weighing Details */}
          <div className="weighing-section">
            <div className="weighing-row">
              <div className="weighing-label">Weighing 1</div>
              <div className="weighing-value">
                {tareWeight.toLocaleString()} kg
              </div>
              <div className="weighing-date">
                {this.formatDate(entryTime) || '2/4/2026'} {this.formatTime(entryTime) || '08:00'}
              </div>
            </div>

            <div className="weighing-row">
              <div className="weighing-label">Weighing 2</div>
              <div className="weighing-value">
                {grossWeight.toLocaleString()} kg
              </div>
              <div className="weighing-date">
                {this.formatDate(exitTime) || '2/4/2026'} {this.formatTime(exitTime) || '10:35'}
              </div>
            </div>
          </div>

          <div className="divider-line"></div>

          {/* Net Weight */}
          <div className="net-weight-section">
            <div className="net-weight-label">Net</div>
            <div className="net-weight-value">
              {netWeight.toLocaleString()} kg
            </div>
          </div>

          <div className="divider-line thick"></div>

          {/* Footer Signatures */}
          <div className="footer-section">
            <div className="signature-box">
              <div className="signature-label">Weighed by:</div>
              <div className="signature-line"></div>
              <div className="signature-name">Mzadcom Operator</div>
            </div>

            <div className="signature-box">
              <div className="signature-label">Scale Operator Signature</div>
              <div className="signature-line"></div>
              <div className="signature-placeholder">___________________</div>
            </div>
          </div>

          {/* Hidden print timestamp */}
          <div className="print-timestamp no-print">
            Printed on: {new Date().toLocaleString()}
          </div>
        </div>
      </div>
    );
  }
}

// Create a forward ref version for compatibility
const ForwardedWeightTicketPrint = React.forwardRef((props, ref) => (
  <WeightTicketPrint {...props} forwardedRef={ref} />
));

export default ForwardedWeightTicketPrint;